@import "config";

.container {
	width: 100%;
	.textarea {
		width: 100%;
		border: solid 1px $color-dark-d5;
		border-radius: $border-radius-sm;
		text-indent: $spacing-inline-nano;

		&:hover,
		&:focus {
			border-color: $color-secondary-light;
			box-shadow: $shadow-level-1;
			outline: 0;
		}

		&:disabled {
			color: $color-dark-d4;
			cursor: not-allowed;
			background-color: $color-light-l2;

			&:hover {
				border-color: $color-dark-d5;
				box-shadow: none;
			}
		}

		&::placeholder {
			color: $color-light-l1;
			font-size: $font-size-xs;
		}
		&.error {
			border-color: $color-error-medium;
			box-shadow: none;
		}
	}
	.helpText {
		display: inline-block;
		font-weight: $font-weight-regular;
		font-size: $font-size-xxxs;
		text-transform: uppercase;
		line-height: $font-line-heights-compact;
		color: $color-dark-d1;
		margin-top: $spacing-stack-quarck;

		&.error {
			color: $color-error-dark;
		}
	}
}
